// extracted by mini-css-extract-plugin
export default {"discussionsContainer":"DiscussionsContainer-module__discussionsContainer--b880"};